import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ON_MENU_TITLE: "På menyen",
      ON_MENU_DESCRIPTION:
        "Her ser du rettene du kan velge mellom hvis du har en av våre nye matkasser. Nye oppskrifter hver uke!",
      ORDER_HERE: "Bestill her",
    },
    se: {
      ON_MENU_TITLE: "Våra middagar",
      ON_MENU_DESCRIPTION:
        "Här ser du middagarna du kan välja mellan om du har en av våra nya matkassar",
      ORDER_HERE: "Välj matkasse",
    },
    dk: {
      ON_MENU_TITLE: "På menuen",
      ON_MENU_DESCRIPTION:
        "Her ser du de retter, du kan vælge imellem, hvis du har valgt en måltidskasse fra RetNemt. Nye opskrifter hver uge.",
      ORDER_HERE: "Bestil her",
    },
  } as const
)[language];
